import { render, staticRenderFns } from "./withdraw-form-add.vue?vue&type=template&id=81a3333e&"
import script from "./withdraw-form-add.vue?vue&type=script&lang=ts&"
export * from "./withdraw-form-add.vue?vue&type=script&lang=ts&"
import style0 from "./withdraw-form-add.vue?vue&type=style&index=0&id=81a3333e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports